module.exports = __webpack_public_path__ + "img/邀请攻略.16a3f24c.png";